var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "render-item",
      class:
        ((_obj = {
          italic: _vm.italic == "all",
          strong: _vm.strong == "all"
        }),
        (_obj["full-line"] = _vm.fullLine),
        _obj),
      style: {
        fontWeight: _vm.strong,
        lineHeight: _vm.lineHeight,
        color: _vm.currentRenderColor
      }
    },
    [
      _vm.wrap ? _c("br") : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.indent, function(i) {
        return [_vm._v("  ")]
      }),
      _vm._v(" "),
      _c("span", { staticClass: "reference-position" }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.labelPosition == "left",
              expression: "labelPosition=='left'"
            }
          ],
          class: {
            italic: _vm.italic == "label",
            strong: _vm.strong == "label"
          }
        },
        [_vm._v(_vm._s(_vm.labelText))]
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.labelPosition == "right",
              expression: "labelPosition=='right'"
            }
          ],
          class: {
            italic: _vm.italic == "label",
            strong: _vm.strong == "label"
          }
        },
        [_vm._v(_vm._s(_vm.labelText))]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4f0dff8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4f0dff8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base_package/RenderFormItem.vue
// module id = null
// module chunks = 